module.exports = __webpack_public_path__ + "img/index2.515a6b0b.png";